import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class SalaryConfigService {
  constructor(private http: HttpClient) {}

  getAllSalaryConfig() {
    return this.http.get(`${environment.apiUrl}/salary-config/get-all`);
  }

  updateSalaryConfig(id: string, data: any) {
    return this.http.put(`${environment.apiUrl}/salary-config/update/${id}`, data);
  }
}
